module.exports = __webpack_public_path__ + "img/edit-button.d1fa6186.svg";